import { hillo } from 'hillo'
import IKDataEntity from '@/plugins/EntityFrameWork/IKDataEntity'
import GlobalConfig from '@/model/global/GlobalSettings'
import { colorList } from '@/model/dataLayer/api/dish/Category'
import VoucherTypes from '@/model/dataLayer/api/Vip/VoucherTypes'
import { cloudV2Url } from '@/model/dataLayer/api/SaaS/SaaSUtils'
import { saveFile } from '@/model/utils/utils'
import { AwardClaimType } from '@/model/dataLayer/api/Vip/Progress'

const awardType = 'membership/award'
const entity = {
  description: {
    header: false,
    formConfig: {
      required: false
    }
  },
  image: {
    header: false,
    type: IKDataEntity.Types.Image,
    tableConfig: {
      required: false
    }
  },
  imageDisplay: {
    displayName: 'image',
    type: IKDataEntity.Types.Integer,
    form: false,
    tableConfig: {
      overwrite: true
    }
  },
  name: {},
  color: {
    type: IKDataEntity.Types.Color,
    formConfig: {
      default: colorList[Math.round(Math.random() * 18)],
      required: false
    },
    header: false,
    tableConfig: { filterable: false }
  },
  awardMax: {
    formConfig: {
      default: 10,
      hint: '积分可以兑换数量的最大值'
    }
  },
  awardStart: {
    header: false,
    formConfig: {
      default: 1,
      required: false
    }
  },
  awardVoucherTypeId: {
    type: IKDataEntity.Types.Option,
    formConfig: {
      type: {
        showButton: true,
        selectItems: async () => { return await VoucherTypes.getList(true) },
        itemText: 'note',
        itemValue: 'id'
      }
    }
  },
  active: {
    type: IKDataEntity.Types.Boolean,
    formConfig: {
      required: false,
      default: true
    }
  },
  repeatable: {
    type: IKDataEntity.Types.Boolean,
    formConfig: {
      required: false,
      default: true
    }
  },
  minOrderAmount: {
    header: false,
    formConfig: {
      default: 0,
      required: false
    }
  },
  claimType: {
    header: false,
    type: IKDataEntity.Types.Option,
    formConfig: {
      required: false,
      default: 'OrderCount',
      type: {
        selectItems: AwardClaimType,
        itemText: 'label',
        itemValue: 'value'
      }
    }
  },
  pointClearAfterLastUsageDays: {
    header: false,
    formConfig: {
      default: 999,
      required: false
    }
  }
}
const config = {
  load: async function () {
    return (await hillo.get(cloudV2Url + awardType + '/byBlId/' + GlobalConfig.blId)).map(it => {
      it.name = it.awardInfo.awardDisplayDetails.name
      it.color = it.awardInfo.awardDisplayDetails.color
      it.image = it.awardInfo.awardDisplayDetails.imageUrl
      it.description = it.awardInfo.awardDisplayDetails.description
      it.awardMax = it.awardInfo.awardMax
      it.awardStart = it.awardInfo.awardStart
      it.awardVoucherTypeId = it.awardInfo.awardVoucherTypeId
      it.claimType = it.awardInfo.claimType
      it.minOrderAmount = it.awardInfo.minOrderAmount
      it.pointClearAfterLastUsageDays = it.awardInfo.pointClearAfterLastUsageDays
      return it
    })
  },
  add: async function (item) {
    item.blId = GlobalConfig.blId
    item.awardDisplayDetails = {
      name: item.name,
      description: item.description,
      imageUrl: await saveFile(item.file),
      color: item.color
    }
    return (await hillo.jsonPost(cloudV2Url + awardType + '/save', {
      ...item
    })).content
  },
  edit: async function (item) {
    item.deletedAt = item.deletedAt ? item.deletedAt : ''
    item.awardDisplayDetails = {
      name: item.name,
      description: item.description,
      imageUrl: item.file ? await saveFile(item.file) : item.image,
      color: item.color
    }
    return (await hillo.jsonPost(cloudV2Url + awardType + '/save', {
      ...item
    })).content
  },
  remove: async function (id) {
    return (await hillo.jsonPost(cloudV2Url + awardType + '/delete/' + id, {
      id
    })).content
  }
}

export default IKDataEntity.ModelFactory(entity, config)

export async function getAwardProgressByBlId () {
  return (await hillo.get(cloudV2Url + awardType + '/progress/blId/' + GlobalConfig.blId, {}))
}
export async function getAwardProgressByUserId (userId) {
  return (await hillo.get(cloudV2Url + awardType + '/progress/byUserId/' + userId, {}))
}
